import {
  AuthenticationDetails,
  CognitoUserPool,
  CognitoUser,
  CognitoUserAttribute,
  ISignUpResult,
} from 'amazon-cognito-identity-js'

const staffPoolData = {
  UserPoolId: COGNITO_STAFF_USER_POOL_ID,
  ClientId: COGNITO_STAFF_CLIENT_ID,
}
const partnerPoolData = {
  UserPoolId: COGNITO_PARTNER_USER_POOL_ID,
  ClientId: COGNITO_PARTNER_CLIENT_ID,
}
const authV2PoolData = {
  UserPoolId: COGNITO_AUTH_V2_USER_POOL_ID,
  ClientId: COGNITO_AUTH_V2_CLIENT_ID,
}
const userPools = {
  staff: new CognitoUserPool(staffPoolData),
  partner: new CognitoUserPool(partnerPoolData),
  authV2: new CognitoUserPool(authV2PoolData),
}

const buildCognitoUser = (poolCode: string, email: string): CognitoUser => {
  const userData = {
    Username: email, // mail address を username として利用
    Pool: userPools[poolCode],
  }
  return new CognitoUser(userData)
}

// ======
// 登録
// ======

// RegisterUser
// emailをusernameとして登録する
export const RegisterUser = async (poolCode: string, email: string, password: string): Promise<string> => {
  // 登録処理
  const result = await ExecRegistration(userPools[poolCode], email, password)
  return result.userSub
}

// ExecRegistration
// 登録成功するとcognito上のuserid(subject)を返す
const ExecRegistration = async (pool: CognitoUserPool, username: string, password: string, userAttrs: CognitoUserAttribute[] = null): Promise<ISignUpResult> => {
  return new Promise((resolve, reject) => {
    pool.signUp(username, password, userAttrs, null, (err, result) => {
      if (err) {
        console.log("Register failed")
        return reject(err)
      }
      console.log("Register success!")
      resolve(result)
    })
  })
}

// MigrateToAutoV2
// authV2用へのコピー登録処理
// 利用ロジックに寄り過ぎてるけどCognitoUserAttribute組み立てがあるのでココに置いとく
export const MigrateToAutoV2 = async (poolCode: string, username: string, email: string, password: string): Promise<string> => {
  const userAttrs: CognitoUserAttribute[] = []
  const emailAttr: CognitoUserAttribute = new CognitoUserAttribute({
    Name: 'email',
    Value: email,
  })

  userAttrs.push(emailAttr)


  // 登録処理
  const result = await ExecRegistration(userPools[poolCode], username, password, userAttrs)

  // 改めて認証
  const cognitoUser = result.user
  const authenticationData = {
    Username: username,
    Password: password,
  }
  const authenticationDetails = new AuthenticationDetails(authenticationData)
  await ExecAuthentication(cognitoUser, authenticationDetails)


  // exec updateAttributes
  const preferredUsernameAttr: CognitoUserAttribute = new CognitoUserAttribute({
    Name: 'preferred_username',
    Value: email,
  })
  userAttrs.push(preferredUsernameAttr)

  cognitoUser.updateAttributes(userAttrs, (err, result) => {
    if (err) {
      console.log(err.message || JSON.stringify(err));
      return;
    }
    console.log('attribute update success')
  })
  return result.userSub
}

// ======
// 認証
// ======
export const AuthenticateUser = async (poolCode: string, email: string, password: string): Promise<string> => {
  // 認証対象ユーザ用意
  const cognitoUser = buildCognitoUser(poolCode, email)

  // 認証用パラメータ用意
  const authenticationData = {
    Username: email,  // mail address を username として利用
    Password: password,
  }
  const authenticationDetails = new AuthenticationDetails(authenticationData)

  // 認証処理
  return ExecAuthentication(cognitoUser, authenticationDetails)
}

// ExecAuthentication
// ログイン成功するとcognito上のuserid(subject)を返す
const ExecAuthentication = async (user: CognitoUser, auth: AuthenticationDetails): Promise<string> => {
  return new Promise((resolve, reject) => {
    user.authenticateUser(auth, {
      onSuccess: (result) => {
        console.log("Login success!")
        const token = result.getIdToken()
        resolve(token.payload.sub)
      },
      onFailure: (err) => {
        console.log("Login failed")
        reject(err)
      }
    })
  })
}

// ======
// パスワードリセット
// sample: usecase 12.
// ======
export const ResetPassword = async (poolCode: string, email: string): Promise<string> => {
  // リセット対象ユーザ用意
  const cognitoUser = buildCognitoUser(poolCode, email)

  // リセット処理
  return ExecForgotPassword(cognitoUser)
}

const ExecForgotPassword = async (user: CognitoUser): Promise<string> => {
  return new Promise((resolve, reject) => {
    user.forgotPassword({
      onSuccess: (result) => {
        console.log("forgot password success!")
        console.log(result)
        resolve("please check your code.")
      },
      onFailure: (err) => {
        console.log("forgot password failed")
        console.log(err)
        reject(err)
      }
    })
  })
}

export const ConfirmResetPassword = async (poolCode: string, email: string, verificationCode: string, newPassword: string): Promise<string> => {
  // 確認対象ユーザ用意
  const cognitoUser = buildCognitoUser(poolCode, email)

  // 確認処理
  return ExecConfirmForgotPassword(cognitoUser, verificationCode, newPassword)
}

const ExecConfirmForgotPassword = async (user: CognitoUser, verificationCode: string, newPassword: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    user.confirmPassword(verificationCode, newPassword, {
      onSuccess: () => {
        console.log("confirm password success!")
        resolve("reset completed.")
      },
      onFailure: (err) => {
        console.log("confirm password failed")
        console.log(err)
        reject(err)
      }
    })
  })
}
